import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import webservice from "../common/Webservice";
import {iconArrowRight, iconCarretRight, iconQuestion} from "../common/Icon";
import {AjaxSpinner, ColumnInformation, PopOver, SegmentedButton, Table} from "@utahdts/dts-react-common";
import PopOverTypes from '@utahdts/dts-react-common/components/pop-over/popOverTypes';
import {isEmpty} from "lodash";
import {footerNotice, formatAmount, formatPriority, MEDIA_SIZES, parseUrl} from "../misc/Shared";
import Media from "react-media";
import clone from 'clone';
import {Link} from "react-router-dom";

const propTypes = {
	currentCobiId:  PropTypes.number,

	currentYear:  PropTypes.number,

	currentPageTitle: PropTypes.string,

	draft: PropTypes.bool,

	history: PropTypes.object.isRequired,

	historyStack: PropTypes.array.isRequired,

	issueText: PropTypes.bool.isRequired,

	itemKey: PropTypes.number.isRequired,
};

const defaultProps = {};

const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentYear: state.app.currentYear,
	currentPageTitle: state.app.currentPageTitle,
	historyStack: state.historyStack,
	issueText: state.app.issueText,
	itemKey: state.app.currentIssueKey,
	draft: state.app.draft
});

class IssueDetail extends React.Component {
	constructor(props) {
		super(props);

		this.displayByChange = this.displayByChange.bind(this);
		this.currentDisplayByOptions = [
			{
				label: 'Statewide',
				value: 'state'
			},
			{
				label: this.props.currentPageTitle ? this.props.currentPageTitle : 'Current level',
				value: 'current'
			}];

		this.state = {
			busy: true,
			currentDisplayBy: 'state',
			dataStateLvl: [],
			dataCurrentLvl: [],
			showContent: true,
			item: {},
			relatedData: [],
			requestorList: [],
			tableData: [],
		};

		this.relatedDataColumns = [
			new ColumnInformation({
				title: 'Location',
				field: 'sortName',
				thClassName: 'text-left hidden-mobile atid_table_header hidden',
				tdCallback: (columnInfo, objectData) => {
					return (<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH} key={columnInfo.field ? columnInfo.field : columnInfo.key}>
						{matches =>
							matches ? (
								<td className="text-left description">
									<span className="mr-spacing-small location">Location:</span>{this.formatMediaRelatedLocation(objectData)}</td>
							) : (
								<td className="text-left description">{this.formatRelatedLocation(objectData)}</td>
							)
						}
					</Media>);
				}
			})
		];

		this.goBack = this.goBack.bind(this);

		this.props.issueText ? this.getIssueText() : this.getIssue();
	}

	componentDidUpdate(prevProps) {
		if(prevProps.currentPageTitle !== this.props.currentPageTitle) {
			this.currentDisplayByOptions.find(option => option.value === 'current').label = this.props.currentPageTitle;
		}

		if(prevProps.currentYear !== this.props.currentYear || prevProps.currentCobiId !== this.props.currentCobiId || prevProps.itemKey !== this.props.itemKey) {
			this.setState({busy: true, currentDisplayBy: 'state'}, () => this.props.issueText ? this.getIssueText() : this.getIssue());
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getIssue() {
		webservice.public.issue.get(this.props.currentYear, 1, this.props.itemKey).then(data => this.setState({
			item: data,
			requestorList: data.requestorList,
			dataStateLvl: data,
			tableData: !isEmpty(data.fundList) ? this.formatData(data) : []
		}, () => this.props.currentCobiId !== 1 ? webservice.public.issue.get(this.props.currentYear, this.props.currentCobiId, this.props.itemKey).then(data => !this.isCancelled && this.setState({
			dataCurrentLvl: data
		}, () => this.getRelated())) : this.getRelated()));
	}

	getIssueText() {
		this.props.draft ?
			webservice.public.otherAction.getDraft(this.props.currentYear, this.props.currentCobiId, this.props.itemKey).then(data => !this.isCancelled && this.setState({
			item: data,
			busy: false
		})) : webservice.public.otherAction.get(this.props.currentYear, this.props.currentCobiId, this.props.itemKey).then(data => !this.isCancelled && this.setState({
				item: data,
				busy: false
			}));
	}

	getRelated() {
		webservice.public.issue.related(this.props.currentYear, this.props.currentCobiId, this.props.itemKey).then(data => this.setState({relatedData: data, busy: false}));
	}

	formatRelatedLocation(detail) {
		let formatLocation;
		if (detail.programActive) {
			formatLocation = <span>{`${detail.agencyName} » ${detail.lineItemName} » `}<Link to={`/${detail.sessionFiscalYear}/${detail.programId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.programName}</Link></span>;
		} else if (detail.lineItemActive) {
			formatLocation = <span>{`${detail.agencyName} » `}<Link to={`/${detail.sessionFiscalYear}/${detail.lineItemId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.lineItemName}</Link></span>;
		} else if (detail.agencyName) {
			formatLocation = <span><Link to={`/${detail.sessionFiscalYear}/${detail.agencyId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.agencyName}</Link></span>;
		}
		return formatLocation;
	}

	formatMediaRelatedLocation(detail) {
		let formatLocation;
		if (detail.programActive) {
			formatLocation = <Link to={`/${detail.sessionFiscalYear}/${detail.programId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.sortName}</Link>;
		} else if (detail.lineItemActive) {
			formatLocation = <Link to={`/${detail.sessionFiscalYear}/${detail.lineItemId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.sortName}</Link>;
		} else if (detail.agencyName) {
			formatLocation = <Link to={`/${detail.sessionFiscalYear}/${detail.agencyId}/issues/${detail.itemKey}${this.props.draft ? '/draft' : ''}`}>{detail.sortName}</Link>;
		}
		return formatLocation;
	}

	displayByChange(field, val) {
		let data = val === 'state' ? clone(this.state.dataStateLvl) : clone(this.state.dataCurrentLvl);
		this.setState({
			[field]: val,
			item: data,
			requestorList: data.requestorList,
			tableData: !isEmpty(data.fundList) ? this.formatData(data) : []
		});
	}

	formatData(data) {
		let tableColumn = [];
		let funds = [];
		let sessions = [];

		const details = [].concat(data.requestDetail, data.priorityDetail, data.appropriationDetailList);

		details.map(detail => {
			!tableColumn.find(column => column.title === detail.fundSource) && tableColumn.push({title: detail.fundSource, sequence: detail.sequence});

			let matches = /^\d{4}(.+)$/.exec(detail.session);
			if(matches && matches[1] !== 'GS' && !sessions.includes(matches[1])) {
				 sessions.push(matches[1]);
			}

		});
		tableColumn.push({ title: 'Funded', sequence: Infinity });

		data.fundList.map(fund => {
			let newFund = { fundName: fund.fundName, 'Funded': { oneTimeAmount: 0, ongoingAmount: 0 } };
			const detailsFounds = details.filter(detail => {return detail.fund == fund.fund });
			detailsFounds.forEach(fund => { newFund[fund.fundSource] = { oneTimeAmount: fund.oneTimeAmount, ongoingAmount: fund.ongoingAmount }; });
			funds.push(newFund);
		});

		let totals = Object.assign({}, ...tableColumn.map(column => ({[column.title]: {oneTimeAmount: 0, ongoingAmount: 0}})));
		totals.fundName = 'Total';
		funds.map(fund => {
			Object.keys(fund).forEach(key => {
				if(!['fundName','Request','Priority', 'Funded'].includes(key)) {
					fund['Funded'].oneTimeAmount += fund[key].oneTimeAmount;
					fund['Funded'].ongoingAmount += fund[key].ongoingAmount;
				}
				if(!['fundName', 'Funded'].includes(key)) {
					totals[key].oneTimeAmount += fund[key].oneTimeAmount;
					totals[key].ongoingAmount += fund[key].ongoingAmount;
				}
			});
			totals['Funded'].oneTimeAmount += fund['Funded'].oneTimeAmount;
			totals['Funded'].ongoingAmount += fund['Funded'].ongoingAmount;
		});

		funds.push(totals);

		tableColumn.sort((a,b) =>  a.sequence - b.sequence).unshift({ title: 'Financing Source' },{ title: ''});
		return { columns: tableColumn, funds: funds, sessions: sessions };
	}

	goBack() {
		//Check if the issue page might have been bookmarked and redirect accordingly
		if(this.props.historyStack.length <= 1){
			this.props.history.push(`/${this.props.currentYear}/${this.props.currentCobiId}/issues${this.props.draft ? '/draft' : ''}`);
		} else {
			const urlValues = parseUrl(this.props.historyStack[this.props.historyStack.length - 2], {years:[this.props.currentYear]});
			this.props.history.push(`/${urlValues.year}/${urlValues.cobiId}/issues${this.props.draft ? '/draft' : ''}`);
		}
	}

	renderTable() {
		return (
			<React.Fragment>
				<div className="badge-legend">
					{this.state.tableData.sessions.map((session, index) =>
						(<span className={'badge background--color' + index} key={session}>{session}</span>)
					)}
					{!isEmpty(this.state.tableData.sessions) ? 'this item is part of a Special Session.' : undefined}
				</div>
				<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}>
					{matches =>
						matches ? (
							this.state.tableData.funds.map((fund, index) => {
								return (
									<div key={fund.fundName + index} className="mb-spacing">
										<table className="fund-table">
											<thead>
											<tr>
												<th colSpan="2" onClick={() => {
													let tableData = {...this.state.tableData};
													tableData.funds[index].hide = !tableData.funds[index].hide;
													this.setState({tableData});
												}}>{fund.fundName} {iconCarretRight(fund.hide ? "" : "rotate-ninety")}</th>
											</tr>
											</thead>
											<tbody className={fund.hide ? "visually-hidden" : ''}>
											{this.renderDetailsMobile(fund)}
											</tbody>
										</table>
									</div>
								);
							})
						) : (
							<table className="issues-details sticky-headers">
								<thead>
								<tr>
									{this.state.tableData.columns.map(column => {
										return <td key={column.title}>{column.title === 'Request' && !isEmpty(this.state.requestorList) ? this.renderSourcePopOver() : undefined}{column.title}</td>;
									})}
								</tr>
								</thead>
								<tbody>
								{this.state.tableData.funds.map((fund, index) => {
									return (
										<React.Fragment key={fund.fundName + index}>
											<tr>
												<td rowSpan="2">{fund.fundName}</td>
												<td className="text-right">One-time</td>
												{this.renderDetails(fund, 'oneTimeAmount')}
											</tr>
											<tr>
												<td className="text-right">Ongoing</td>
												{this.renderDetails(fund, 'ongoingAmount')}
											</tr>
										</React.Fragment>
									);
								})}
								</tbody>
							</table>
						)
					}
				</Media>
			</React.Fragment>
		);
	}

	renderDetails(fund, amount) {
		let details = [];
		for (let i = 2; i < this.state.tableData.columns.length; i++) {
			details.push(<td key={fund.fundName + amount + this.state.tableData.columns[i].title} className={"text-right" + (['Request', 'Priority'].includes(this.state.tableData.columns[i].title) ? ' blue' : '')}>
				{fund[this.state.tableData.columns[i].title] ?
					'$' + formatAmount(fund[this.state.tableData.columns[i].title][amount], 0)
					: '$' + formatAmount(0, 0)
				}
			</td>);
		}
		return details;
	}

	renderDetailsMobile(fund) {
		let details = [];
		for (let i = 2; i < this.state.tableData.columns.length; i++) {
			let key = this.state.tableData.columns[i].title;
			fund[key] && details.push(
				<React.Fragment key={fund.fundName + i}>
					<tr>
						<td rowSpan="2" className={['Request', 'Priority'].includes(this.state.tableData.columns[i].title) ? ' blue' : ''}>{key} {fund.fundName === 'Total' && key === 'Request' && !isEmpty(this.state.requestorList) ? this.renderSourcePopOver() : undefined}</td>
						<td className="text-right amount amount-one-time">{'$' + formatAmount(fund[key].oneTimeAmount, 0)}</td>
					</tr>
					<tr>
						<td className="text-right amount amount-ongoing">{'$' + formatAmount(fund[key].ongoingAmount, 0)}</td>
					</tr>
				</React.Fragment>
			);
		}
		return details;
	}

	renderSourcePopOver() {
		return (
			<PopOver
				anchor={
					iconQuestion()
				}
				className="mr-spacing-small inline-block"
				classNameAnchor="sources-button"
				classNamePopup="elevation--z4 sources"
				dismissible={true}
				focusable={true}
				popOverType={PopOverTypes.LISTBOX}
				position={PopOver.POSITION.TOP}
			>
				<div className="source-list">
					{this.state.requestorList.map((item, index) => {
						return (
							<div key={item.name + index} className="source-list__item">
								<div className="source-list__item__title">{item.name}</div>
								<div>One-time: ${formatAmount(item.oneTimeAmount, 0)}</div>
								<div>Ongoing: ${formatAmount(item.ongoingAmount, 0)}</div>
							</div>
						);
					})}
				</div>
			</PopOver>
		);
	}

	render() {
		return (
			<section>
				<a onClick={this.goBack} className="italic-text content">
					<span className="reverse">{iconArrowRight()}</span> Back to all issues
				</a>
				{this.state.busy && <AjaxSpinner size={30} className="css-spinner hcenter vcenter with-backdrop" backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>}
				<header className="flex space-between p-spacing no-flex-mobile">
					<div>
						<h1 className="no-margin">{this.props.issueText ? this.state.item.issueName : this.state.item.itemName}</h1>
						<div dangerouslySetInnerHTML={{__html: this.props.issueText ? this.state.item.issueTextHtml : this.state.item.itemText}} />
					</div>
					{this.state.item.itemPriorityOnetime || this.state.item.itemPriorityOngoing ? <div className="gray-box">
						<strong>Priority</strong>
						<p className="no-margin">One-time: <strong>{formatPriority(this.state.item.itemPriorityOnetime)}</strong></p>
						<p className="no-margin">Ongoing: <strong>{formatPriority(this.state.item.itemPriorityOngoing)}</strong></p>
					</div> : undefined}
				</header>
				<section className="description-area content fr-view no-flex-mobile">
					{this.props.currentCobiId !== 1 && !this.props.issueText && <SegmentedButton
						label="Show:"
						field="currentDisplayBy"
						className="mr-spacing flex-mobile"
						value={this.state.currentDisplayBy}
						options={this.currentDisplayByOptions}
						onChange={this.displayByChange}
					/>}
					{!isEmpty(this.state.tableData) && this.renderTable()}
				</section>

				{this.state.relatedData.length > 0 ? <div className="collapsible-section mt-spacing-large">
					<div className="clearfix collapsible-section__title">
						<h3 className="float-left">Additional Funding Areas</h3>
						<a href="#" onClick={(e) => {
							e.preventDefault();
							this.setState({showContent: !this.state.showContent});
						}} className="float-right mt-spacing-small atid_expand_carret_other">{iconCarretRight(this.state.showContent ? "rotate-ninety" : "")}</a>
					</div>
					<div className={this.state.showContent ? '' : 'visually-hidden'}>
						<Table
							columns={this.relatedDataColumns}
							list={this.state.relatedData}
							className="issues issues-other"
							trClassName="atid_row"
						/>
					</div>
				</div> : undefined}

				{footerNotice('mt-spacing-large')}
			</section>
		);
	}
}

IssueDetail.propTypes = propTypes;
IssueDetail.defaultProps = defaultProps;

export default connect(mapStateToProps)(IssueDetail);
